import { render, staticRenderFns } from "./advancedset.vue?vue&type=template&id=d96901e8&scoped=true"
import script from "./advancedset.vue?vue&type=script&lang=js"
export * from "./advancedset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96901e8",
  null
  
)

export default component.exports